export default "__VITE_ASSET__BqjBr_5j__"